export interface SkeletonProps {
  className?: string
}

export const Skeleton = ({ className }: SkeletonProps) => (
  <div
    className={`bg-[#EBEDF0] h-4 w-full animate-pulse rounded-lg ${
      className ?? ''
    }`}
  />
)

export default Skeleton
